// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"83ce1910","937":"668f3ac0"}[chunkId] + ".chunk.js";
};